/**
 * Common utility functions
 */

import { POSTAL_CODE_PATTERN, EMAIL_PATTERN } from '../constants';

/**
 * Validates Canadian postal code format
 */
export function validatePostalCode(postalCode: string): boolean {
  const cleaned = postalCode.trim().toUpperCase().replace(/\s+/g, '');
  return POSTAL_CODE_PATTERN.test(cleaned);
}

/**
 * Formats postal code as A1A 1A1
 */
export function formatPostalCode(value: string): string {
  const cleaned = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  
  if (cleaned.length <= 3) {
    return cleaned;
  } else if (cleaned.length <= 6) {
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
  } else {
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)}`;
  }
}

/**
 * Validates email format
 */
export function validateEmail(email: string): boolean {
  return EMAIL_PATTERN.test(email);
}

/**
 * Gets current year for copyright
 */
export function getCurrentYear(): number {
  return new Date().getFullYear();
}

/**
 * Calculates scroll position state
 */
export function calculateScrollState(
  scrollLeft: number,
  scrollWidth: number,
  clientWidth: number,
  tolerance: number = 1
): { isAtStart: boolean; isAtEnd: boolean } {
  const maxScroll = scrollWidth - clientWidth;
  return {
    isAtStart: scrollLeft <= 0,
    isAtEnd: scrollLeft >= maxScroll - tolerance,
  };
}

/**
 * Scroll tolerance constant
 */
export const SCROLL_TOLERANCE = 1;

